import { Toast } from '@kaleyra/kds';

const KDSToast = ( title = '', type:any) => {

    return Toast(
        {
            title: title,
            message: '',
            closable: false,
            delay: 5,
        },
        {
            type: type ,
            leftIcon: true,
        },
        {
            title: undefined,
        },
        {
            title: undefined,
        },
    );
};

export default KDSToast;